import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=381a80bf&scoped=true&"
import script from "./UserCenter.vue?vue&type=script&lang=js&"
export * from "./UserCenter.vue?vue&type=script&lang=js&"
import style0 from "./UserCenter.vue?vue&type=style&index=0&id=381a80bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a80bf",
  null
  
)

component.options.__file = "UserCenter.vue"
export default component.exports